// extracted by mini-css-extract-plugin
export default {"currentLot":"TicketExchange_currentLot__2gIga"};